import { of, throwError, timer } from 'rxjs';
import { catchError, switchMapTo, take } from 'rxjs/operators';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { ElectronService } from '../../electron.service';
export abstract class DatabaseBaseService {

  get tenantId() {
    return this.loginUserService.tenantId;
  }

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) { }

  protected ipcSendSync(channel: string, ...args: any[]) {
    const sendSyncOf = of(this.electronService.sendSyncCommand(channel, ...args));
    return timer(50)
      .pipe(switchMapTo(sendSyncOf))
      .pipe(take(1))
      .pipe(catchError((error: any) => throwError(() => error.json)));
  }
}
